// ajax模块
export default {
  'ERR500.tips': 'هناك بعض الأخطاء، قد اتصلنا بالمطورين لإصلاح هذا الخلل. يرجى إعادة المحاولة لاحقا. شكرا جزيلا.',
};
